module.exports = __webpack_public_path__ + "img/emoji_weixiao.36c33512.png";